import React from 'react';
import styled from 'styled-components';
import Column from 'gatsby-theme-pagebuilder/src/components/column/index';
import Review from './review';
import ReviewWithImage from './review-with-image';

const getComponent = (variant) => {
  switch (variant) {
    case 'withImage':
      return ReviewWithImage;
    default:
      return Review;
  }
};

const ReviewBlock = ({
  columnWidth,
  align,
  justify,
  card,
  order,
  title,
  variant,
  reviews,
  offset,
}) => {
  if ((reviews || []).length === 0) {
    return null;
  }
  const Component = getComponent(variant);
  return (
    <Column
      columnWidth={columnWidth}
      align={align}
      justify={justify}
      card={card}
      order={order}
      offset={offset}
    >
      {title && <Title>{title}</Title>}
      <Reviews>
        {reviews.map((review) => (
          <Component key={review.id} {...review} />
        ))}
      </Reviews>
    </Column>
  );
};

const Title = styled.h2`
  margin-bottom: .75rem;
  text-transform: uppercase;
  font-weight: 400;
`;

const Reviews = styled.div`
  display: grid;
  grid-gap: ${({ theme }) => theme.grid.columnGap};
  grid-template-columns: 1fr;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export default styled(ReviewBlock)``;
